import { render, staticRenderFns } from "./server_list.vue?vue&type=template&id=e56d8ea4&scoped=true"
import script from "./server_list.vue?vue&type=script&lang=js"
export * from "./server_list.vue?vue&type=script&lang=js"
import style0 from "./server_list.vue?vue&type=style&index=0&id=e56d8ea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56d8ea4",
  null
  
)

export default component.exports